import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, CATEGORIES } from "@/lib/pfc";
import ArticleCard from "@/components/ArticleCard";
import PromoCard from "@/components/PromoCard";

// Curated talent promos surfaced in the Magazine. Add new ones here.
const TALENT_PROMOS = [
  {
    handle: "dj_raystar_",
    url: "https://www.instagram.com/dj_raystar_?igsh=bXZ1NTRxMmxvYmg5",
    displayName: "DJ RayStar",
    tagline: "Living loud, spinning vibes. South Florida's phenomenal DJ — every Taco Tuesday & Wednesday Karaoke at Bushwick Lounge, Oakland Park FL.",
  },
  {
    handle: "thetinyk",
    url: "https://www.instagram.com/thetinyk?igsh=MTQ0czdyMTU5dG9qaw==",
    displayName: "TheTinyK",
    tagline: "Bold visuals. Bigger energy. Catch the latest drop on IG.",
  },
  {
    handle: "ayezay_officialig2",
    url: "https://www.instagram.com/ayezay_officialig2?igsh=dzlzdjRvZ3Vnemll",
    displayName: "Aye Zay",
    tagline: "New flyers, fresh sound. Tap in for the rollout.",
  },
];

export default function Magazine() {
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState("");

  useEffect(() => {
    const q = category ? `?category=${category}` : "";
    api.get(`/articles${q}`).then((r) => setItems(r.data));
  }, [category]);

  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14" data-testid="magazine-page">
      <div className="mb-12">
        <div className="label text-pfc-gold mb-3">The Magazine</div>
        <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl text-white uppercase leading-[0.9]">
          Stories That <span className="gold-text">Move</span> Culture
        </h1>
      </div>

      {/* Talent Promos / Flyers strip */}
      <section className="mb-14" data-testid="magazine-promos">
        <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
          <div>
            <div className="label text-pfc-gold mb-2">Talent Promos</div>
            <h2 className="font-display text-2xl sm:text-3xl text-white uppercase leading-[0.95]">
              Latest <span className="gold-text">Flyers</span> & Drops
            </h2>
          </div>
          <Link
            to="/contact?subject=Promo+Flyer+Submission"
            data-testid="submit-flyer-btn"
            className="font-sub uppercase tracking-[0.2em] text-xs px-5 py-3 border border-pfc-gold text-pfc-gold hover:bg-pfc-gold hover:text-ink-900 transition"
          >
            Submit Your Flyer →
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="promo-grid">
          {TALENT_PROMOS.map((p) => (
            <PromoCard key={p.handle} {...p} />
          ))}
        </div>
      </section>

      <div className="flex gap-2 flex-wrap mb-10">
        <button onClick={() => setCategory("")} className={`font-sub uppercase tracking-[0.2em] text-xs px-4 py-3 border transition ${!category ? "bg-pfc-gold border-pfc-gold text-ink-900" : "border-white/15 text-white/70 hover:border-white/40"}`} data-testid="mag-filter-all">All</button>
        {CATEGORIES.map((c) => (
          <button key={c.key} onClick={() => setCategory(c.key)} className={`font-sub uppercase tracking-[0.2em] text-xs px-4 py-3 border transition ${category === c.key ? "bg-pfc-gold border-pfc-gold text-ink-900" : "border-white/15 text-white/70 hover:border-white/40"}`} data-testid={`mag-filter-${c.key}`}>
            {c.label.split(" ")[0]}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="magazine-grid">
        {items.map((a) => <ArticleCard key={a.article_id} article={a} />)}
      </div>
    </div>
  );
}
